module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('strong', [_vm._v("TABLE OF CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#int"
    }
  }, [_vm._v("Introduction")]), _vm._v(" by Jay Conrad Levinson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01#pt1"
    }
  }, [_c('strong', [_vm._v("Part 1: Big Dogs and Guerrillas—an Introduction to Guerrilla Deal-Making")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1"
    }
  }, [_c('strong', [_vm._v("Chapter 1: Donald Trump vs. Mao Tse-Tung at the Negotiating Table")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchapb"
  }, [_c('em', [_vm._v("A fractured fairy tale about what might have happened when Donald Trump, the consummate capitalist, and Mao Tse-Tung, the dedicated communist, tried to negotiate a deal on building a Trump casino-hotel in Shanghai")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1lev1sec1"
    }
  }, [_vm._v("Trump Sends a Feeler to Mao")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1lev1sec2"
    }
  }, [_vm._v("Mao Thinks About It—Hard")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1lev1sec3"
    }
  }, [_vm._v("Mao Takes Action")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1lev1sec4"
    }
  }, [_vm._v("Mao Comes to Sin City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1lev1sec5"
    }
  }, [_vm._v("The Guerrilla Comes to The Haircut’s Office")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1lev1sec6"
    }
  }, [_vm._v("Mao Leaves Suddenly")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1lev1sec7"
    }
  }, [_vm._v("Are You a Big Dog or a Guerrilla at Heart?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1lev1sec8"
    }
  }, [_vm._v("What the Rest of Your Book Is About")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1lev1sec9"
    }
  }, [_vm._v("Answers to 13 Questions in This Chapter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 2: 18 Reasons Why Americans Aren’t That Good at Deal-Making—and What You Can Do About It!")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchapb"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(" reveals to you the 18 reasons why Americans are sub-par at deal-making. It also shows you how to avoid the dumb mistakes and assumptions that cause Americans to get a lot less than they could when they try to close a deal")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sneak Preview of This Chapter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Try Thinking Like Mexicans—They’re Natural Guerrillas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 Reasons Why Americans Are Often Lousy at Getting What They Want")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2lev1sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Anybody Can Become a Big Winner—Think Small! Sam Walton Did!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2lev1sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What’s Coming Up in Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 3: Know Your Enemy—How to Get Inside the Big Dog’s Mind")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchapb"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")]), _vm._v(" tells you what’s")]), _vm._v(" really "), _c('em', [_vm._v("going on inside the mind of the big dog—the powerful opponent guerrillas face in the deal-making process. After you read this chapter, you’ll know how to take advantage of his")]), _vm._v(" Big I, Little You "), _c('em', [_vm._v("attitude. You’ll learn many subtle guerrilla tricks to win him over to your side")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Impressions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Get the Big Dog Not Only to Listen Seriously to You but Also Accept Your Proposal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ultimate Guerrilla")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3lev1sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What You Learned Here and What’s Coming Up Next")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3lev1sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Get the Big Dog to Listen Seriously to You—Answer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02#pt2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part 2: Donald Wayne Hendon’s 100 Most Powerful Influence Weapons and Mao Tse-Tung’s 22 Most Powerful Guerrilla Warfare Weapons")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 4: Don and Mao—Their Most Powerful Weapons")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchapb"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")]), _vm._v(" gives you the complete—and improved—list of Don Hendon’s 365 deal-making tactical Weapons contained in his")]), _vm._v(" 365 Powerful Ways to Influence "), _c('em', [_vm._v("book. The 100 most powerful techniques are in bold-face type, so they stand out. We’ve also included Mao Tse-Tung’s 22 favorite Guerrilla Weapons")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch4lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Donald Wayne Hendon’s 365 Powerful Deal-Making Weapons")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchapd"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch4lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31 Preparation Weapons")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchapd"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch4lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121 Assertive Weapons")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchapd"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch4lev1sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92 Defensive Weapons")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchapd"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch4lev1sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 Submissive Weapons")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchapd"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch4lev1sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24 Cooperative Weapons")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchapd"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch4lev1sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81 Dirty Tricks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchapd"
  }, [_vm._v("Plus 1 Leap Year Weapon")]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch4lev1sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mao Tse-Tung’s 22 Most Powerful Guerrilla Weapons: List Compiled from Mao’s "), _c('em', [_vm._v("Yu Chi Chan")]), _vm._v(" by Donald Hendon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/part03#pt3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part 3: Donald Wayne Hendon’s 50 Most Powerful and "), _c('em', [_vm._v("Under")]), _vm._v("-Used Tactical Weapons: Guerrillas Should Use Them Because They’re Powerful and Because Big Dogs Won’t Expect Them")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchapb"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapters 5")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(", and "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" thoroughly discuss the 50 most powerful Weapons that most people don’t use very often. They are ideally suited for guerrillas. Use them to surprise big dogs and other guerrillas when you make deals with them. You’ll put them off-balance. Taking advantage of their rhythm when they’re unsettled will help you win big. More than 200 winning counter-punches are also in these five chapters")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 5: Eight Preparation Weapons")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch5lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Learn from Children")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch5lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Right Attitude—Earn the Right to Learn Other Guy’s Needs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch5lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Don’t Give Away the Store for a Smile")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch5lev1sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mistakes—Admit and Learn from Them")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch5lev1sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Escalation Is Stupid")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch5lev1sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thinking Small Is Smart")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch5lev1sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Empty Stomach or Full Stomach?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch5lev1sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mornings or Afternoons?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 6: 14 Assertive Weapons")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch6lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sudden, Unexpected Moves")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch6lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zap! Turn Liabilities into Assets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch6lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wild and Crazy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch6lev1sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When Buyers Pursue Sellers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch6lev1sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rule of Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch6lev1sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Make Them Invest Lots of Time")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch6lev1sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Know Your Enemy and Know Yourself")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch6lev1sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turn the Other Guy’s Assistants into Heroes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch6lev1sec9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Imply")]), _vm._v(" Your Power—Don’t "), _c('em', [_vm._v("Display")]), _vm._v(" It")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch6lev1sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scare, Then Rescue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch6lev1sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Swarming Ambush, Flash Mobs, Tuangou")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch6lev1sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Take First, Then Talk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch6lev1sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Become Untouchable")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch6lev1sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deaf Ear")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 7: 12 Defensive Weapons")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch7lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Distract and Unbalance, Japanese-Style")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch7lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Least Commitment, Most Power")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch7lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Power of Silence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch7lev1sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Watch His Body Language")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch7lev1sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Manipulate Him with "), _c('em', [_vm._v("Your")]), _vm._v(" Body Language")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch7lev1sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Body Language of Touching")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch7lev1sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Position Power—Office Layout")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch7lev1sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Concession Patterns")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch7lev1sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grapevine Gossip")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch7lev1sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dog Ate My Homework")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch7lev1sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lighten Up")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch7lev1sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Allies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 8: Eight Cooperative Weapons")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch8lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Power of Patience")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch8lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Admit Your Ignorance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch8lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Listen Well—The Cheapest and Most Important Concession of All")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch8lev1sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Active Listening")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch8lev1sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bonus—Leave Something on the Table at the End")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch8lev1sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Make the Other Guy Look Good")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch8lev1sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Make Him Think You Lost")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch8lev1sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mental Seduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 9: Eight Dirty Tricks")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch9lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trap Him—Make Sure He Can’t Go Somewhere Else")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch9lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sign Contract, Escalate Immediately")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch9lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sign Contract, Re-Negotiate Immediately")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch9lev1sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bait-and-Switch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch9lev1sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Act Untouchable—Entitled to Special Privileges")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch9lev1sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Act Smug—I Know a Lot About You")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch9lev1sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frightening Ambience, Manipulative Music")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch9lev1sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deliberately Embarrass Him")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/part04#pt4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part 4: Donald Wayne Hendon’s 50 Most Powerful and "), _c('em', [_vm._v("Over")]), _vm._v("-Used Tactical Weapons: Guerrillas Should Use Them Even Though the Big Dog Will Expect Them, Simply Because They’re So Powerful")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchapb"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapters 10")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(", and "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" contain the 50 most powerful Weapons that are")]), _vm._v(" over-"), _c('em', [_vm._v("used by people all over the world. You’ll see them used against you quite often. More than 200 winning counter-punches are also in these six chapters—weapons which the other guy won’t expect. Putting him off-balance this way gives you an enormous advantage")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 10: Two Preparation Weapons")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Make Concessions—20 Do’s and 20 Don’ts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Show Me Yours, Then I’ll Show You Mine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 11: 27 Assertive Weapons")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Playing Dumb Is Smart")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Act Astonished!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Don’t Give Him Your Best Offer too Soon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev1sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Don’t Accept His First Offer too Quickly")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev1sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wise and Shrewd Deadlines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev1sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Take Advantage of His Blind Spots")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev1sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Divide and Conquer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev1sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Overwhelm Him—Act Arrogant")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev1sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I’m the Greatest!—Act Egotistical")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev1sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Good Guy, Bad Guy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev1sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Decoy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev1sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Size Matters—Big Pot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev1sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Big Bluff")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev1sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wish Lists and Reality Lists")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev1sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Smooth Talk, Charm, Flattery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev1sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pretend to Have Plenty of Information")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev1sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Keep Pressure on the Other Guy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev1sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elvis Has Left the Building")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev1sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Don’t Accept His "), _c('em', [_vm._v("No")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev1sec20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tell Him “I’m Ready to Withdraw”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev1sec21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tradition, Custom, and Conformity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev1sec22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Make Him Feel Guilty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev1sec23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reward and Punishment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('a', {
    attrs: {
      "id": "page_xx"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev1sec24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Put Him on the Defensive")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev1sec25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nibble Away")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev1sec26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Let’s Look at the Record")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11lev1sec27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whose Problem? Mine, Ours, or Yours?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 12: 12 Defensive Weapons")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Power of Powerlessness and Creeping Paralysis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Remind the Other Guy of His Competition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Funny Money")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12lev1sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lower His Expectations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12lev1sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Power of Being Unprepared")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12lev1sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Run-Around")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12lev1sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("No More Money")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12lev1sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Withhold Important Information")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12lev1sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Honesty—How Much?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12lev1sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nagging and Bullying")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12lev1sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Gotta Do Better Than That!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12lev1sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trade-Offs Yes, Promises No")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 13: Three Submissive Weapons")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drool and Choose")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Split the Difference—Whose Dumb Mistake?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Take Whatever You Can Get")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 14: Two Cooperative Weapons")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reciprocity—Subtle and Obvious")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Don’t Concede—Tempt Him Instead")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 15: Four Dirty Tricks")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Let Me Ask Mommy First")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fear—Scare the Hell Out of Him")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Obvious Lying—Not Just Exaggerated Big Talk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15lev1sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Use His 2 G-Spots: Greed and Gullibility")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part05#pt5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part 5: Body Language and Concession-Making for Guerrillas")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 16: Guerrilla Body Language")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchapb"
  }, [_c('em', [_vm._v("In "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")]), _vm._v(", you’ll learn how to tell what’s going on in the minds of both big dogs and other guerrillas without them even")]), _vm._v(" suspecting "), _c('em', [_vm._v("that you "), _c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }), _vm._v("know. How to tell if they’re lying or if they’re trying to dominate you. What their touches mean. Get more clues from how they set up their office. And best of all, you’ll also learn how to manipulate them with")]), _vm._v(" your own "), _c('em', [_vm._v("body language. If you do it correctly, they probably won’t suspect a thing")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Simple It Is—the Six Essentials")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Training: Is He Interested in What You’re Saying? Does He Like It? The 52 Fundamental Gestures of Guerrilla Body Language")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16lev1sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Advanced Course in Body Language—5 Parts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchapdv"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16lev2sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 1: The Body Language of Lying—40 Gestures")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchapdv"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16lev2sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 2: The Body Language of Dominance—18 Gestures")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchapdv"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16lev2sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 3: The Body Language of Touching—12 Hints to Follow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchapdv"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16lev2sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 4: The Language of Office Furniture Placement—19 Positions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchapdv"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16lev2sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 5: How to Manipulate Him with Your Body Language")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16lev1sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("But Wait, There’s More . . . Very Advanced Stuff")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16lev1sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 17: Guerrilla Concession-Making")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchapb"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")]), _vm._v(" is all about how to make concessions the right way—and how to make the other guy give you more concessions than he really wants to")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Recognize Concession Patterns You Both Make")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Put a Dollar Value on Each Concession You Both Make")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How You Can Make Concessions the Right Way: 20 Do’s and 20 Don’ts. All of Them Have to Do with Keeping His Expectations as Low as Possible")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchapdv"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17lev2sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 Do’s")]), _vm._v(": "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17lev2sec1lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acting")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17lev2sec1lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Agents")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17lev2sec1lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Attitude")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17lev2sec1lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deadlines")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17lev2sec1lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dollar Value")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17lev2sec1lev6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Limited Authority")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17lev2sec1lev7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Listen Well")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17lev2sec1lev8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Timing")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17lev2sec1lev9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trade-Off’s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchapdv"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17lev2sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 Don’t’s")]), _vm._v(": "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17lev2sec2lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Assumptions")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17lev2sec2lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deadlines")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17lev2sec2lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dollars")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17lev2sec2lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ego")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17lev2sec2lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mistakes")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17lev2sec2lev6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Timing")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17lev2sec2lev7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Words")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17lev1sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/part06#pt6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part 6: Wrapping It Up")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 18: How to Become the Ultimate Guerrilla")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchapb"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")]), _vm._v(" shows you how to become so skilled at guerrilla deal-making that you’ll make the right moves at the right times—almost automatically. You’ll also learn how to use Jay’s 54 Golden Rules for Guerrilla Marketing Excellence")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ch18lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction: Become the Ultimate Guerrilla by Becoming Unconsciously Skillful at Making Deals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ch18lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Get to Stage Four Quickly—11 Important Hints")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ch18lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54 Golden Rules for Guerrillas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ch18lev1sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ch18lev1sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("But Before You Close the Book Cover . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ch18lev1sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About Jay Conrad Levinson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ch18lev1sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About Donald Wayne Hendon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-subchap"
  }, [_vm._v("A Traditional Irish Friendship Wish")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c4da751","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/tableofcontents.vue
// module id = 75
// module chunks = 0